<template>
  <div @mouseenter="playRandomAnimation()">
      <lottie class="lottie" :options="defaultOptions" :height="400" :width="400" v-on:animCreated="handleAnimation"/>
  </div>
</template>

<script>

import Lottie from '@/lottie.vue';
import * as animationData from '../assets/animations/logo-animation.json';

export default {
    name: 'app',
    components: {
      'lottie': Lottie
    },
    data() {
      return {
        defaultOptions: {
            animationData: animationData.default,
            loop: false,
            autoplay: false,
        },
        animationSpeed: 1,
        animationSequences: {
                flip: [0,70],
                fall: [70,170],
                // blink: [171, 270],
                expand: [271, 287]
            }
      }
    },
    methods: {
      handleAnimation: function (anim) {
        this.anim = anim;
      },

      stop: function () {
        this.anim.stop();
      },

      play: function () {
        this.anim.play();
      },

      pause: function () {
        this.anim.pause();
      },

      onSpeedChange: function () {
        this.anim.setSpeed(this.animationSpeed);
      },

      playRandomAnimation: function () {
        this.anim.playSegments(this.selectRandomElemment(this.animationSequences), true);
      },
      selectRandomElemment: function (obj) {
        var keys = Object.keys(obj);
        return obj[keys[ keys.length * Math.random() << 0]];
      }   
    }
  }
</script>

<style lang="scss">
    .lottie {
        width: 260px !important;
        height: 44px !important;
    }
</style>